import { OrganizationResourcePage } from './OrganizationResourcePage';
export default OrganizationResourcePage;
